// Centralized Appcues helpers for SPA usage

const APPCUES_ID = import.meta.env.VITE_APPCUES_ID;
export const HELP_CENTER_FLOW_ID = "ff3cb527-1b5b-46ad-b765-7021416ff926";

let initStarted = false;

export function initAppcues() {
  if (typeof window === "undefined") return;
  if (initStarted) return;
  initStarted = true;
  try {
    // enable URL Detection fails for SPA so we need update in App.js instead.
    window.AppcuesSettings = { enableURLDetection: false };

    // If snippet already present, do nothing
    if (
      window.Appcues &&
      (window.Appcues.SNIPPET_VERSION || window.Appcues.invoked)
    ) {
      return;
    }

    const s = document.createElement("script");
    s.src = `https://fast.appcues.com/${APPCUES_ID}.js`;
    s.async = true;
    // Insert before first script tag
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(s, firstScript);
    } else {
      document.head.appendChild(s);
    }
  } catch (e) {
    console.warn("Appcues failed to load:", e);
  }
}

export function page() {
  try {
    if (window.Appcues && typeof window.Appcues.page === "function") {
      window.Appcues.page();
    }
  } catch {}
}

export function identify(userId, traits) {
  try {
    if (
      window.Appcues &&
      userId &&
      typeof window.Appcues.identify === "function"
    ) {
      window.Appcues.identify(userId, traits);
    }
  } catch {}
}
export function reset() {
  try {
    if (window.Appcues && typeof window.Appcues.reset === "function") {
      window.Appcues.reset();
    }
  } catch {}
}

export function debug(enable = true) {
  try {
    if (window.Appcues && typeof window.Appcues.debug === "function") {
      window.Appcues.debug(enable);
    }
  } catch {}
}

export function track(name, props) {
  try {
    if (window.Appcues && typeof window.Appcues.track === "function") {
      window.Appcues.track(name, props);
    }
  } catch {}
}
